import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=171e8d96"
import script from "./CatalogForm.vue?vue&type=script&lang=ts"
export * from "./CatalogForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports